import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

const API = `${process.env.VUE_APP_ROOT_API}/api/v2/accounts`;
const CLIENT_ID = "65d8664966fb53f7b4c844ca";

// Restore token from sessionStorage on load
const savedToken = sessionStorage.getItem("accountToken");
if (savedToken) {
  axios.defaults.headers.common["Authorization"] = `Bearer ${savedToken}`;
}

const store = new Vuex.Store({
  state: {
    token: savedToken || null,
    user: null,
  },

  getters: {
    isAuthenticated(state) {
      return !!state.token;
    },
    user(state) {
      return state.user;
    },
  },

  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
      if (token) {
        sessionStorage.setItem("accountToken", token);
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      } else {
        sessionStorage.removeItem("accountToken");
        delete axios.defaults.headers.common["Authorization"];
      }
    },
    SET_USER(state, user) {
      state.user = user;
    },
  },

  actions: {
    async register(_, { first_name, last_name, email, password }) {
      const { data } = await axios.post(`${API}/register`, {
        _idClient: CLIENT_ID,
        first_name,
        last_name,
        email,
        password,
      });
      return data;
    },

    async verify(_, { email, code }) {
      const { data } = await axios.post(`${API}/verify`, {
        _idClient: CLIENT_ID,
        email,
        code,
      });
      return data;
    },

    async resendCode(_, { email }) {
      const { data } = await axios.post(`${API}/resend-code`, {
        _idClient: CLIENT_ID,
        email,
      });
      return data;
    },

    async login({ commit }, { email, password }) {
      const { data } = await axios.post(`${API}/login`, {
        _idClient: CLIENT_ID,
        email,
        password,
      });
      commit("SET_TOKEN", data.token);
      return data;
    },

    async fetchUser({ commit }) {
      const { data } = await axios.get(`${API}/me`);
      commit("SET_USER", data);
      return data;
    },

    async updateProfile({ commit }, { first_name, last_name, phone, address }) {
      const payload = {};
      if (first_name !== undefined) payload.first_name = first_name;
      if (last_name !== undefined) payload.last_name = last_name;
      if (phone !== undefined) payload.phone = phone;
      if (address !== undefined) payload.address = address;
      const { data } = await axios.put(`${API}/me`, payload);
      commit("SET_USER", data);
      return data;
    },

    async changePassword(_, { currentPassword, newPassword }) {
      const { data } = await axios.post(`${API}/change-password`, {
        currentPassword,
        newPassword,
      });
      return data;
    },

    async fetchSubmissions() {
      const { data } = await axios.get(`${API}/submissions`);
      return data;
    },

    async requestPasswordReset(_, { email }) {
      const { data } = await axios.post(`${API}/request-password-reset`, {
        _idClient: CLIENT_ID,
        email,
      });
      return data;
    },

    async resetPassword(_, { email, code, newPassword }) {
      const { data } = await axios.post(`${API}/reset-password`, {
        _idClient: CLIENT_ID,
        email,
        code,
        newPassword,
      });
      return data;
    },

    logout({ commit }) {
      commit("SET_TOKEN", null);
      commit("SET_USER", null);
    },
  },
});

export default store;
